import { render } from "./SolutionDetails.vue?vue&type=template&id=28c723d6&scoped=true"
import script from "./SolutionDetails.vue?vue&type=script&lang=js"
export * from "./SolutionDetails.vue?vue&type=script&lang=js"

import "./SolutionDetails.vue?vue&type=style&index=0&id=28c723d6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c723d6"]])

export default __exports__